"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFollowLocation = exports.apiCall = exports.createOptions = exports.makeUrlFactory = void 0;
const qs_1 = __importDefault(require("qs"));
const ApiError_1 = require("./ApiError");
const INVALID_TOKEN = 'Token invalid or expired';
const makeUrlFactory = (host, version) => (path, queryObj = {}) => {
    const queryString = qs_1.default.stringify(queryObj, { addQueryPrefix: true });
    const prefixVersion = version ? `api/${version}` : '';
    const baseUrl = `/${prefixVersion}${path}${queryString}`.replace(/\/+/, '/');
    return `${host}${baseUrl}`;
};
exports.makeUrlFactory = makeUrlFactory;
const checkStatus = (response) => {
    if (response.status >= 400) {
        let errMessage = `Error getting data from the API with status: ${response.status}, ${response.statusText}`;
        if (response.status === 401)
            errMessage = INVALID_TOKEN;
        return response
            .json()
            .catch(() => response)
            .then((res) => {
            throw new ApiError_1.ApiError(`url: ${response.url}, message: ${res.message || errMessage}`, response.status, res);
        });
    }
    return Promise.resolve(response);
};
const isFormData = (data) => {
    return data instanceof FormData;
};
const createOptions = (options = {}, token) => {
    const tokenString = token && token.get();
    const defaultOptions = { method: 'GET', credentials: !token || tokenString ? 'same-origin' : 'include' };
    // When body is of type FormData, Browser automatically attaches the ContentType with additional factors like boundary, encoding etc.
    const defaultHeaders = isFormData(options.body) ? {} : { 'Content-Type': 'application/json' };
    const paramHeaders = options.headers || {};
    const authorizationHeaders = tokenString ? { authorization: tokenString } : {};
    const mergedHeaders = {
        ...defaultHeaders,
        ...paramHeaders,
        ...authorizationHeaders,
    };
    return {
        ...defaultOptions,
        ...options,
        headers: mergedHeaders,
    };
};
exports.createOptions = createOptions;
const exec = ({ url, options: { bypassErrorHandlers, withResponse = false, ...options } = {}, apiErrorHandler, }) => {
    return fetch(url, options)
        .then(checkStatus)
        .then((res) => {
        if (withResponse)
            return res;
        const resolveResponse = () => {
            if (res.status === 204)
                return Promise.resolve(null);
            const contentTypeHeader = res.headers.get('content-type');
            if (contentTypeHeader) {
                if (contentTypeHeader.includes('text')) {
                    return res.text();
                }
                if (contentTypeHeader.includes('image')) {
                    return res.blob();
                }
            }
            return res.json();
        };
        // try to parse the response body to JSON.
        // If it fails, just return the response as is
        return resolveResponse().catch(() => res);
    })
        .catch((err) => {
        if (err.name === ApiError_1.ApiErrorName && apiErrorHandler && !bypassErrorHandlers) {
            apiErrorHandler(err);
        }
        else {
            throw err;
        }
    });
};
const getMethod = ({ url, token, qsOptions, headers, apiErrorHandler, fetchOptions }) => (data, options = {}) => {
    const query = data ? qs_1.default.stringify(data, { addQueryPrefix: true, indices: false, ...qsOptions }) : '';
    return exec({
        url: `${url}${query}`,
        options: (0, exports.createOptions)({ ...fetchOptions, ...options, headers: { ...headers, ...(options.headers || {}) }, method: 'GET' }, token),
        apiErrorHandler,
    });
};
const postMethod = ({ url, token, headers, apiErrorHandler, fetchOptions }) => (data = {}, options = {}) => exec({
    url,
    options: (0, exports.createOptions)({
        ...fetchOptions,
        ...options,
        headers: { ...headers, ...(options.headers || {}) },
        body: isFormData(data) ? data : JSON.stringify(data),
        method: 'POST',
    }, token),
    apiErrorHandler,
});
const patchMethod = ({ url, token, headers, apiErrorHandler, fetchOptions }) => (data = {}, options = {}) => exec({
    url,
    options: (0, exports.createOptions)({
        ...fetchOptions,
        ...options,
        headers: { ...headers, ...(options.headers || {}) },
        body: isFormData(data) ? data : JSON.stringify(data),
        method: 'PATCH',
    }, token),
    apiErrorHandler,
});
const putMethod = ({ url, token, headers, apiErrorHandler, fetchOptions }) => (data = {}, options = {}) => exec({
    url,
    options: (0, exports.createOptions)({
        ...fetchOptions,
        ...options,
        headers: { ...headers, ...(options.headers || {}) },
        body: JSON.stringify(data),
        method: 'PUT',
    }, token),
    apiErrorHandler,
});
const deleteMethod = ({ url, token, headers, apiErrorHandler, fetchOptions }) => (data = {}, options = {}) => exec({
    url,
    options: (0, exports.createOptions)({
        ...fetchOptions,
        ...options,
        headers: { ...headers, ...(options.headers || {}) },
        body: JSON.stringify(data),
        method: 'DELETE',
    }, token),
    apiErrorHandler,
});
const apiCall = ({ host = '', token, version, options, headers, apiErrorHandler, fetchOptions, }) => (path) => {
    const makeUrl = (0, exports.makeUrlFactory)(host, version);
    const url = makeUrl(path);
    return {
        get: getMethod({ url, token, qsOptions: options, apiErrorHandler, headers, fetchOptions }),
        post: postMethod({ url, token, apiErrorHandler, headers, fetchOptions }),
        patch: patchMethod({ url, token, apiErrorHandler, headers, fetchOptions }),
        put: putMethod({ url, token, apiErrorHandler, headers, fetchOptions }),
        delete: deleteMethod({ url, token, apiErrorHandler, headers, fetchOptions }),
    };
};
exports.apiCall = apiCall;
const generateFollowLocation = (token, host) => async (p) => {
    const res = await p;
    const location = res.headers.get('Location');
    if (location)
        return exec({ url: `${host}${location}`, options: (0, exports.createOptions)({ method: 'GET' }, token) });
    throw new Error('Location not found on response, could not follow location');
};
exports.generateFollowLocation = generateFollowLocation;
//# sourceMappingURL=apiCall.js.map